<template>
  <span
    class="tag is-uppercase is-light mr-1"
    :title="worker.type"
    :class="workerClass"
  >
    {{ workerTypeName }}
  </span>
</template>

<script lang="ts">
import { isEmpty } from 'lodash'
import { mapStores } from 'pinia'
import { type PropType, defineComponent } from 'vue'

import { WORKER_TYPE_COLORS } from '@/config'
import { useAuthStore, useWorkerStore } from '@/stores'
import type { Worker } from '@/types/worker'

export default defineComponent({
  props: {
    worker: {
      type: Object as PropType<Worker>,
      required: true,
    },
  },
  mounted() {
    if (this.authStore.isVerified && isEmpty(this.workerStore.workerTypes))
      this.workerStore.listWorkerTypes()
  },
  computed: {
    ...mapStores(useAuthStore, useWorkerStore),
    workerTypeName(): string {
      // If worker types have not been listed yet, use the slug
      if (!this.workerStore.workerTypes) return this.worker.type
      const workerType = Object.values(this.workerStore.workerTypes).find(
        ({ slug }) => slug === this.worker.type,
      )
      /*
       * ListWorkerTypes might not include the type for this worker, because to non-admins,
       * only the types from workers accessible to the user will be included.
       * So we still have to fall back to the slug.
       */
      return workerType?.display_name ?? this.worker.type
    },
    workerClass(): string {
      return WORKER_TYPE_COLORS[this.worker.type]?.cssClass ?? WORKER_TYPE_COLORS.default.cssClass
    },
  },
})
</script>
